<div class="text-right">
  <button class="btn btn-sm btn-primary-link pl-0" (click)="quickAddClient()"><i class="fas fa-plus mr-2"></i><span i18n *ngIf="!addText">Ustvari nov kontakt</span><span *ngIf="addText">{{ addText }}</span></button>
</div>

<label i18n-aria-label="Client autocomplete" aria-label="Išči kontakt..." class="relative">
  <input type="text" matInput [formControl]="control"
         i18n-placeholder="Client autocomplete"
         data-test="autocomplete-client-input"
         placeholder="Išči..."
         style="padding-left: 2.25rem !important"
         [matAutocomplete]="clientAutocomplete" [ngClass]="{'mb-4' : !withLabelMargin}">

  <div class="absolute text-grayLight pointer-events-none left-0 top-0 ml-3">
    <i class="fas fa-search"></i>
  </div>
</label>


<mat-autocomplete [autoActiveFirstOption]="isLoadingData" #clientAutocomplete="matAutocomplete"
                  (optionSelected)="onSelected($event)" autocomplete="off">

  <div *ngIf="clients">
    <mat-option *ngFor="let client of clients; let i = index" [value]="client" style="height: auto;" class="leading-normal">
      <div class="py-3 pointer-events-none">
        <div class="leading-normal">
          <app-client-table-cell [client]="client" [disableLink]="true"></app-client-table-cell>
        </div>

        <ul class="text-grayDark text-xs ml-6" [ngClass]="{'mt-1': client.clientDetails.personRegistrationNumber ||
                client.clientDetails.personTaxNumber ||
                client.clientDetails.companyRegistrationNumber ||
                client.clientDetails.companyTaxNumber}">
          <ng-container *ngIf="client.isPerson">
            <li class="leading-relaxed" *ngIf="client.clientDetails.personRegistrationNumber">
              <span i18n class="">EMŠO:</span>
              <span class="ml-1 font-semibold">{{ client.clientDetails.personRegistrationNumber }}</span>
            </li>
            <li class="leading-relaxed" *ngIf="client.clientDetails.personTaxNumber">
              <span i18n class="">Davčna št.:</span>
              <span class="ml-1 font-semibold">{{ client.clientDetails.personTaxNumber }}</span>
            </li>
          </ng-container>
          <ng-container *ngIf="!client.isPerson">
            <li class="leading-relaxed" *ngIf="client.clientDetails.companyRegistrationNumber">
              <span i18n class="">Matična št.:</span>
              <span class="ml-1 font-semibold">{{ client.clientDetails.companyRegistrationNumber }}</span>
            </li>
            <li class="leading-relaxed" *ngIf="client.clientDetails.companyTaxNumber">
              <span i18n class="">Davčna št.:</span>
              <span class="ml-1 font-semibold">{{ client.clientDetails.companyTaxNumber }}</span>
            </li>
          </ng-container>
        </ul>
      </div>
      <hr class="py-0 my-0">
    </mat-option>

    <mat-option *ngIf="!isLoadingData && clients.length === 0" value="">
      <span class="italic"><span i18n="Autocomplete results">Ni rezultatov</span></span>
    </mat-option>
  </div>

  <mat-option *ngIf="isLoadingData">
    <app-content-shimmer></app-content-shimmer>
  </mat-option>

</mat-autocomplete>
